module.exports = __webpack_public_path__ + "img/arrowRight.a2adc4dd.svg";